import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { QuestionBankAnswerReviewDialogComponent } from './question-bank-answer-review-dialog.component';

export const QUESTION_BANK_ANSWER_REVIEW_DIALOG_ID = 'question-bank-answer-review-dialog';

export interface QuestionBankAnswerReviewDialogInput {
  questionId: string;
}

@Injectable({ providedIn: 'root' })
export class QuestionBankAnswerReviewDialogService extends AbstractDialogService<
  QuestionBankAnswerReviewDialogInput,
  void,
  typeof QuestionBankAnswerReviewDialogComponent
> {
  readonly id = QUESTION_BANK_ANSWER_REVIEW_DIALOG_ID;
  protected readonly component = QuestionBankAnswerReviewDialogComponent;

  protected override readonly options: DialogOptions = {
    cssClass: 'fullscreen',
    canDismiss: true,
    backdropDismiss: false,
    showBackdrop: true,
    handle: false,
    breakpoints: undefined,
    initialBreakpoint: undefined,
  };

  override async openDialog(config: { input: QuestionBankAnswerReviewDialogInput }) {
    return super.openDialog({
      ...config,
      options: {
        ...this.options,
        componentProps: {
          questionId: config.input.questionId,
        },
      },
    });
  }
}
